export type Language = 'en' | 'gu';

export const translations = {
  en: {
    // Navbar
    login: 'Login',
    signUp: 'Sign Up',
    myProfile: 'My Profile',
    myOrders: 'My Orders',
    loyaltyPoints: 'Loyalty Points',
    expenseVault: 'Expense Vault',
    familyCabinet: 'Family Cabinet',
    referEarn: 'Refer & Earn',
    subscriptions: 'Subscriptions',
    whatsappAlerts: 'WhatsApp Alerts',
    adminDashboard: 'Admin Dashboard',
    ownerAnalytics: 'Owner Analytics',
    pharmacistPanel: 'Pharmacist Panel',
    pickupQueue: 'Pickup Queue',
    signOut: 'Sign Out',
    // Nav categories
    medicines: 'Medicines',
    vitamins: 'Vitamins',
    skincare: 'Skincare',
    personalCare: 'Personal Care',
    babyChild: 'Baby & Child',
    devices: 'Devices',
    ayurvedic: 'Ayurvedic',
    wellness: 'Wellness',
    bySymptom: 'By Symptom',
    drugChecker: 'Drug Checker',
    // Topbar
    topbar: 'Free delivery on orders above ₹500 • Nadiad, Gujarat • Call: +91-2638-XXXXXX',
    // Home
    shopByCategory: 'Shop By Category',
    viewAll: 'View All',
    featuredProducts: 'Featured Products',
    joinNow: "Join Now — It's Free",
    milanPointsTitle: 'Milan Points — Your Loyalty Rewards',
    milanPointsDesc: 'Earn 1 point for every ₹10 spent. Redeem 100 points = ₹10 off. The more you shop, the more you save!',
    // Product
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    prescriptionRequired: 'Prescription Required',
    inStock: 'In Stock',
    reviews: 'Reviews',
    description: 'Description',
    usage: 'Usage',
    // Cart
    cart: 'Cart',
    checkout: 'Checkout',
    // General
    search: 'Search medicines, vitamins...',
    loading: 'Loading...',
    noResults: 'No results found',
  },
  gu: {
    // Navbar
    login: 'લૉગ ઇન',
    signUp: 'નોંધણી',
    myProfile: 'મારી પ્રોફાઇલ',
    myOrders: 'મારા ઓર્ડર',
    loyaltyPoints: 'લૉયલ્ટી પૉઇન્ટ',
    expenseVault: 'ખર્ચ વૉલ્ટ',
    familyCabinet: 'ફેમિલી કેબિનેટ',
    referEarn: 'રેફર કરો અને કમાઓ',
    subscriptions: 'સબ્સ્ક્રિપ્શન',
    whatsappAlerts: 'વ્હૉટ્સઍપ અલર્ટ',
    adminDashboard: 'એડમિન ડૅશબૉર્ડ',
    ownerAnalytics: 'ઓનર ઍનૅલિટિક્સ',
    pharmacistPanel: 'ફાર્માસિસ્ટ પૅનલ',
    pickupQueue: 'પિકઅપ ક્યૂ',
    signOut: 'સાઇન આઉટ',
    // Nav categories
    medicines: 'દવાઓ',
    vitamins: 'વિટામિન',
    skincare: 'સ્કિનકૅર',
    personalCare: 'પર્સનલ કૅર',
    babyChild: 'બાળ સ્વાસ્થ્ય',
    devices: 'ઉપકરણ',
    ayurvedic: 'આયુર્વેદિક',
    wellness: 'વૅલ્નૅસ',
    bySymptom: 'લક્ષણ દ્વારા',
    drugChecker: 'દવા ચૅકર',
    // Topbar
    topbar: '₹500 ઉપરના ઓર્ડર પર મફત ડિલિવરી • નડિયાદ, ગુજરાત • ફોન: +91-2638-XXXXXX',
    // Home
    shopByCategory: 'કૅટેગરી અનુસાર ખરીદી',
    viewAll: 'બધું જુઓ',
    featuredProducts: 'ફીચર્ડ ઉત્પાદન',
    joinNow: 'અત્યારે જ જોડાઓ — મફત',
    milanPointsTitle: 'મિલન પૉઇન્ટ — તમારા લૉયલ્ટી રિવૉર્ડ',
    milanPointsDesc: 'દર ₹10 ખર્ચ પર 1 પૉઇન્ટ કમાઓ. 100 પૉઇન્ટ = ₹10 ની છૂટ. વધુ ખરીદો, વધુ બચાઓ!',
    // Product
    addToCart: 'કાર્ટમાં ઉમેરો',
    outOfStock: 'સ્ટૉક ખૂટી ગઈ',
    prescriptionRequired: 'પ્રિસ્ક્રિપ્શન જરૂરી',
    inStock: 'સ્ટૉકમાં',
    reviews: 'સમીક્ષા',
    description: 'વર્ણન',
    usage: 'ઉપયોગ',
    // Cart
    cart: 'કાર્ટ',
    checkout: 'ચૅકઑઉટ',
    // General
    search: 'દવા, વિટામિન શોધો...',
    loading: 'લોડ થઈ રહ્યું છે...',
    noResults: 'કોઈ પરિણામ નથી',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
